export default class SearchUserPModel {
    constructor(data = {}) {
        this.apellido = data.apellido || '';
        this.titular = data.titular || '';
        this.rut = data.rut || '';
        this.bps = data.bps || '';
        this.correo = data.correo || '';
        this.telefono = data.telefono || '';
        this.viniedo = data.viniedo || '';
    }
}
